import { render, staticRenderFns } from "./ArticlePageList.vue?vue&type=template&id=4a215358&scoped=true&"
import script from "./ArticlePageList.vue?vue&type=script&lang=js&"
export * from "./ArticlePageList.vue?vue&type=script&lang=js&"
import style0 from "./ArticlePageList.vue?vue&type=style&index=0&id=4a215358&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./ArticlePageList.vue?vue&type=style&index=1&id=4a215358&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a215358",
  null
  
)

export default component.exports